import { Ring } from '@blocks/Loading'
import { toFileString } from '@helpers'
import useAuth from '@hooks/useAuth'
import { PDFDownloadLink } from '@react-pdf/renderer'
import React, { useEffect, useRef, useState } from 'react'
import { ReactComponent as DownloadIcon } from '@icons/download.svg'
import Button from '@blocks/Button'
import FileSaver from 'file-saver'
import AcceptanceCertificatePdf from '@customer/pdfs/AcceptanceCertificatePdf'
import { useSalonContext } from '@customer/components/pages/Salon/context'

export default function CertificateDownload() {
    const [download, setDownload] = useState(false)
    const { salon } = useSalonContext()
    const { user } = useAuth<Resources.Customer>()
    const filename = `${toFileString(salon.state.name)}.pdf`

    if (!download)
        return <Button type="tertiary" icon={<DownloadIcon />} onClick={() => setDownload(true)}>Certificate</Button>

    return (
        <PDFDownloadLink document={<AcceptanceCertificatePdf salon={salon} customer={user} />} style={{ textDecoration: "none" }} fileName={filename}>
            {({ blob, url, loading, error }) => {
                useEffect(() => {
                    if (loading) return
                    if (!blob) return
                    FileSaver.saveAs(blob, filename)
                    setDownload(false)
                }, [loading])

                return <Button type="tertiary" icon={<Ring height={24} />}>Certificate</Button>
            }}
        </PDFDownloadLink>
    )
}